<template>
<div style="width:760px;height:570px;">
  <div style="position: relative;width:100%;height:100%;" v-if="img_detail.url.indexOf('pdf') != -1">
    <!-- <img :src="readUrl+img_detail.url" style="border:#ccc 1px solid;max-height:100%;max-width:100%;"> -->
    <img src="../../assets/images/zhang1.gif" class="yiguidang" v-if="img_detail.is_place && img_detail.is_place==2">
    <img src="../../assets/images/zhang4.gif" class="yiguidang" v-if="img_detail.is_really && img_detail.is_really==1">
    <object v-if="!img_detail.url_list || img_detail.url_list.length==0" :data="img_detail.url" type="application/pdf" width="100%" height="570px" style="border:#ccc 1px solid;"></object>
  </div>
  <div style="position: relative;width:100%;height:100%;" v-if="img_detail.url.indexOf('jpg') != -1 || img_detail.url.indexOf('jpeg') != -1 || img_detail.url.indexOf('png') != -1">
    <img src="../../assets/images/zhang1.gif" class="yiguidang" v-if="img_detail.is_place && img_detail.is_place==2">
    <img src="../../assets/images/zhang4.gif" class="yiguidang" v-if="img_detail.is_really && img_detail.is_really==1">
    <img :src="img_detail.url" style="border:#ccc 1px solid;max-height:100%;max-width:100%;">
  </div>
</div>
</template>

<script>
  export default {
  props: ['img_detail', 'closeMain'],
  data() {
    return {
    }
  },
  created() {
    this.pdfFile = null
    this.file = null
  },
  methods: {
    close_dig() {
      this.$emit('closeMain', 0)
    }
  },
  components: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.upload-icon {
  display: flex;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  height: 28px;
  padding-left: 10px;
  padding-right: 10px;
  background-color: rgb(59, 95, 232);
  border-radius: 1px;
  border-color: #5867dd;
  font-weight: 500;
  font-size: 12px;
  color: white;
  margin: 1px;
}

.scale-icon {
  display: flex;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  width: 33px;
  height: 28px;
  background-color: #F5F5F5;;
  border-radius: 1px;
  font-weight: 500;
  font-size: 12px;
  color: #333333;
  text-align: center;
  padding: 2px;

}
.scale-icon :active {
  color: rgb(59, 95, 232);
}
.scale-icon :hover {
  color: rgb(59, 95, 232);
}

.text-icon {
  display: flex;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  height: 28px;
  width: 90%;
  background-color: rgb(59, 95, 232);
  border-radius: 1px;
  border-color: #5867dd;
  font-weight: 500;
  font-size: 10px;
  color: white;
  margin-top: 20px;

}

.hidden {
  display: none !important;
}

.SealContainer {
  z-index: 99999;
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
}

.SealContainer .mask {
  background: #000000;
  opacity: 0.3;
}

.content-title {
  font-size: 16px;
  text-align: center;
  border-bottom: 1px solid rgb(59, 95, 232);
  color: rgb(59, 95, 232);
  margin-top: 10px;
}


.SealContainer-content {
  position: relative;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  background: white;
  display: flex;
  flex-direction: column;
  padding: 10px;
  align-items: center;
}

.SealContainer-layout {
  position: relative;
  width: 60%;
  height: 80vh;
  overflow-y: auto;
  background: white;
  z-index: 100;
  display: flex;
  flex-direction: column;
  padding: 10px;
  align-items: center;
}

.subcontent {
  width: 80%;
  display: flex;
  flex-direction: column;
  text-align: left;
  margin-bottom: 10px;
  font-family: simsun;
}

.subcontent .title {
  font-weight: 600;
}

.subcontent .value {
  font-weight: 400;
  -webkit-line-clamp: 1;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.left-section {
  position: fixed;
  width: 88px;
  height: 100%;
  background:#F5F5F5;
  border: 1px solid #e8e8e8;
  align-items: center;
  display: flex;
  flex-direction: column
}

.main-section {
  padding-top: 20px;
  margin-left:88px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #808080;
  overflow: hidden;
  position: relative
}

@media (max-width: 767px) {
  .SealContainer-layout {
    position: relative;
    width: 90%;
    height: 90vh;
    overflow-y: auto;
    background: white;
    z-index: 100;
    display: flex;
    flex-direction: column;
    padding: 10px;
    align-items: center;
  }

  .subcontent {
    width: 95%;
    display: flex;
    flex-direction: column;
    text-align: left;
    margin-bottom: 10px;
    font-family: simsun;
  }

  .left-section {
    position: fixed;
    width: 0px;
    height: 100%;
    background:#F5F5F5;
    border: 1px solid #e8e8e8;
    align-items: center;
    display: none;
    flex-direction: column;
  }

  .main-section {
    padding-top: 20px;
    margin-left:0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #808080;
    overflow: hidden
  }
}
</style>



// WEBPACK FOOTER //
// image.vue?44181924